import { render, staticRenderFns } from "./BankServiceForm.vue?vue&type=template&id=825467b8&"
import script from "./BankServiceForm.vue?vue&type=script&lang=js&"
export * from "./BankServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports